import { __decorate } from "tslib";
// NPM
import { Component, Vue } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
setInteractionMode("passive");
// QUINLAN
import Layout from "../../layouts/auth.vue";
import { AuthModule } from "../../../store/modules/auth.module";
let SessionTimeOut = /** @class */ (() => {
    let SessionTimeOut = class SessionTimeOut extends Vue {
        constructor() {
            super(...arguments);
            // DATA
            this.title = "Session Time Out";
            this.appUrl = "";
            this.tenantCode = "";
        }
        signOut() {
            AuthModule.Logout();
        }
        created() {
            this.appUrl = AuthModule.appUrl;
        }
    };
    SessionTimeOut = __decorate([
        Component({
            name: "SessionTimeOut",
            components: {
                Layout,
            },
        })
    ], SessionTimeOut);
    return SessionTimeOut;
})();
export default SessionTimeOut;
